import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";

const app = firebase.initializeApp({
    apiKey: "AIzaSyDpKLx-3Q-wnb0ush4yiYkALDxbacnlCyo",
    authDomain: "sorbete-pop.firebaseapp.com",
    databaseURL: "https://sorbete-pop.firebaseio.com",
    projectId: "sorbete-pop",
    storageBucket: "sorbete-pop.appspot.com",
    messagingSenderId: "200231868675",
    appId: "1:200231868675:web:c0b5a8f6689d2e5d043136",
    measurementId: "G-WGBK1N5SHH",
});

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();

export { app, googleAuthProvider, facebookAuthProvider };
